import DirectionsIcon from '@mui/icons-material/Directions'
import LocalParking from '@mui/icons-material/LocalParking'
import PedalBikeIcon from '@mui/icons-material/PedalBike'
import {
    Box,
    CircularProgress,
    IconButton,
    List,
    Stack,
} from '@mui/material'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import AutomaticSheet from 'src/components/sheet/AutomaticSheet'
import SheetHeader from 'src/components/sheet/SheetHeader'
import { useGetMicromobilityDetailMicromobilityMicromobilityIdGet } from 'src/generated/brezavta/queries'
import { useGeolocationDialog } from 'src/lib/geolocation'
import MicromobilityVehicle from 'src/components/MicromobilityVehicle'

export const Route = createFileRoute('/micromobility/$stopId')({
    component: MicromobilityStop,
})

function MicromobilityStop() {
    const { stopId } = Route.useParams()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { acquireLocation, LoadingDialog } = useGeolocationDialog()

    const { data, isLoading } = useGetMicromobilityDetailMicromobilityMicromobilityIdGet({
        path: {
            micromobility_id: stopId,
        },
    })

    if (isLoading) {
        return (
            <AutomaticSheet>
                <Box sx={{ display: 'flex', height: window.innerHeight / 2, justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Box>
            </AutomaticSheet>
        )
    }

    const vehicles = data?.vehicle_list

    return (
        <AutomaticSheet>
            <SheetHeader
                heading={data?.name}
                actions={data && (
                    <IconButton
                        size="small"
                        aria-label={t('Navigate to')}
                        onClick={() => {
                            acquireLocation(
                                location => navigate({
                                    to: '/plan',
                                    search: {
                                        from: {
                                            title: t('My location'),
                                            latitude: location.latitude,
                                            longitude: location.longitude,
                                            type: 'GPS' as const,
                                        },
                                        to: {
                                            title: data.name,
                                            latitude: data.lat,
                                            longitude: data.lon,
                                            type: 'POI' as const,
                                        },
                                    } as Record<string, unknown> as any, // eslint-disable-line @typescript-eslint/no-explicit-any
                                }),
                                () => navigate({
                                    to: '/plan',
                                    search: {
                                        to: {
                                            title: data.name,
                                            latitude: data.lat,
                                            longitude: data.lon,
                                            type: 'POI' as const,
                                        },
                                    } as Record<string, unknown> as any, // eslint-disable-line @typescript-eslint/no-explicit-any
                                }),
                            )
                        }}
                    >
                        <DirectionsIcon fontSize="small" />
                    </IconButton>
                )}
            >
                <Stack gap={2} direction="row">
                    <LocalParking />
                    {data?.spaces}
                    <PedalBikeIcon />
                    {data?.vehicles}
                </Stack>
            </SheetHeader>
            <LoadingDialog />
            {vehicles !== undefined && vehicles.length == 0 && data?.vehicles == 0 && (
                <div style={{ textAlign: 'center' }}>
                    {t('The station is empty')}
                </div>
            )}
            {/* else, just say no details available if data.vehicles > 0 */}
            {vehicles.length == 0 && data?.vehicles > 0 && (
                <div style={{ textAlign: 'center' }}>
                    {t('No details available')}
                </div>
            )}
            <List>
                {(vehicles || []).map((item: typeof vehicles[number], index: number) => {
                    return <MicromobilityVehicle key={index} item={item} index={index} />
                })}
            </List>
        </AutomaticSheet>
    )
}

export default MicromobilityStop
